import DefaultList from "@Common/DefaultList";
import { useNavigationHandler } from "@hook";
import { handleCopyBuffer } from "@utils";
import { inject, observer } from "mobx-react";

const TestSiteList = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigation = useNavigationHandler();

        const handleRowClick = (e) => {
            mainStore.setMainStore("detailData", {});
            navigation(e.originalEvent, `/test-site/${e.data._id}`);
        };
        return (
            <DefaultList
                dataKey={"abtest_absites"}
                keysToGet={["_id", "title", "site"]}
                apiUrl="/abtest/absites"
                titleName="A/B тест для сайта"
                titleAddButton="тест"
                keyFilterSearch="name"
                handleRowClick={handleRowClick}
                checkbox={false}
                columns={[
                    {
                        field: "_id",
                        header: "ID",
                        style: { width: "5%", maxWidth: "20px", overflow: "hidden" },
                        body: (item) => (
                            <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                                <span className=" text">ID</span>
                                <i className="pi pi-clone"></i>
                            </div>
                        ),
                    },
                    {
                        field: "title",
                        header: "Название",
                        sortable: false,
                        body: (item) => <span className="list__name">{item.title}</span>,
                        style: { width: "40%" },
                        type: "text",
                    },
                    { field: "site", header: "Сайт", sortable: false, style: { width: "10%" }, type: "text" },
                ]}
            />
        );
    }),
);

export default TestSiteList;
